import Reveal from "@/pages/home/components/Reveal";
import SectionTitle from "@/pages/home/components/SectionTitle";
import { verifySteps } from "@/mocks/home";

export default function VerifySteps() {
  return (
    <section id="verify" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="开工前先核对"
            title="三步核对，别让一个错字耽误一晚上"
            desc="绝大多数“打不开”都能在这三步里定位。顺序别颠倒：先排除人为输错，再判断网络环境，最后才轮到更换入口线路。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {verifySteps.map((step, index) => (
            <Reveal key={step.no} delay={index * 90}>
              <article className="flex h-full flex-col rounded-xl border border-background-200/80 bg-background-100/60 p-6 transition-colors hover:border-primary-300">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <span className="font-heading text-3xl font-black text-background-300">{step.no}</span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {step.tips.map((tip) => (
                    <span
                      key={tip}
                      className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900"
                    >
                      {tip}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}